// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../action-list';
import {getLugheightUOM} from '../../shared/repositories';

export const readLugheightUOM = () =>
    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const data = await getLugheightUOM();

            dispatch({
                data,
                type: actions.UPDATE_CLAIM_TRACK_LUGHEIGHT_UNIT_COLLECTION
            });

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/claim/track/action-creators/lug-height-units.js